import {useContext} from 'react'

import Card from './back-components/card'
import BackFields from './back-components/back-fields'
import FrontMinature from './back-components/front-minature'
import UserSettings from './back-components/user-settings'
import IosAppLink from './back-components/ios-app-link'
import ShareButton from './back-components/share-button'
import DescriptionAndUpdateLog from './back-components/description-and-update-log'

import {AppContext} from '/providers/app-context'

const AppleBack = () => {

  const {user} = useContext(AppContext)

  return (
    <Card>
      <ShareButton show={user.preferences.show_standard_items} />
      <FrontMinature show={user.preferences.show_standard_items} />
      <DescriptionAndUpdateLog show={user.preferences.show_standard_items} />
      <IosAppLink />
      <UserSettings show={user.preferences.show_standard_items} />
      <BackFields  />
    </Card>
  )
}

export default AppleBack